module.exports = __webpack_public_path__ + "static/media/parabens-aniversario.d45d3042.png";